module.exports = __webpack_public_path__ + "media/images/top/common/img_voice_worry02-0f71be259ac79a9e069842711910f287.png";